import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {WorksTypes} from "src/app/enums/Works.enum";
import type {WorksModel} from "src/app/models/WorksModel";
import type {AddWorkCompletionPromptState} from "src/app/modules/shared/interfaces/add-work-completion-prompt.interface";
import {ModalService} from "./modal.service";

const QUICK_COMPLETION_TYPES = new Set<WorksTypes>([
  WorksTypes.Series,
  WorksTypes.Animation,
  WorksTypes.Game,
  WorksTypes.Manga,
  WorksTypes.Comic,
  WorksTypes.Book,
]);

@Injectable({
  providedIn: "root",
})
export class AddWorkCompletionPromptService {
  public readonly modalId = "add_work_quick_completion_prompt";
  private readonly promptSubject =
    new BehaviorSubject<AddWorkCompletionPromptState | null>(null);
  public readonly prompt$ = this.promptSubject.asObservable();

  constructor(private readonly modalService: ModalService) {}

  public shouldPromptForWork(work: WorksModel): boolean {
    return QUICK_COMPLETION_TYPES.has(work.type);
  }

  public openPrompt(work: WorksModel): void {
    if (!this.shouldPromptForWork(work)) {
      return;
    }

    this.promptSubject.next({work});
    this.modalService.openModal(this.modalId);
  }

  public clearPrompt(): void {
    this.promptSubject.next(null);
  }
}
